import { Box, Flex, P, Small } from "orcs-design-system";

import { formatRequisitionState } from "src/util/requisitionState";

type WhyStillDraftProps = {
  state?: string | null | undefined;
  draftBlockers?: readonly string[] | null | undefined;
};

/** Read-only explanation when guardrails keep a row in Draft (POWER/ADMIN). */
const WhyStillDraft = ({ state, draftBlockers }: WhyStillDraftProps) => {
  const blockers = (draftBlockers ?? []).filter(
    (line) => line.trim().length > 0
  );
  if (formatRequisitionState(state) !== "Draft" || blockers.length === 0) {
    return null;
  }
  return (
    <Box data-testid="requisition-why-still-draft">
      <Small uppercase weight="bold" color="greyDark" display="block" mb="xs">
        Why still Draft
      </Small>
      <Flex flexDirection="column" gap="xs" pl="r">
        {blockers.map((line, index) => (
          <P key={`${index}-${line}`} m="0" fontSize="2">
            {line}
          </P>
        ))}
      </Flex>
    </Box>
  );
};

export default WhyStillDraft;
